"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeServerDate = void 0;
var luxon_1 = require("luxon");
function normalizeServerDate(serverDate) {
    if (!serverDate)
        return null;
    return luxon_1.DateTime.fromISO(serverDate, { setZone: true })
        .toUTC()
        .toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'");
}
exports.normalizeServerDate = normalizeServerDate;
